module.exports = __webpack_public_path__ + "img/notifications.6a325ad2.svg";